module.exports = __webpack_public_path__ + "media/images/menu/draco-94d272fbb4f7cd2c198f6ed39a80743a.jpg";